import { Icon } from "@chakra-ui/react";
import { MdArchive, MdRestore } from "react-icons/md";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";

type Props = Partial<TooltipIconButtonProps> & {
  isArchive: boolean;
  labelSuffix?: string;
};

export default function ArchiveRestoreIconButton({
  isArchive,
  labelSuffix,
  ...rest
}: Props) {
  return (
    <TooltipIconButton
      label={`${isArchive ? "Archive" : "Unarchive"}${
        labelSuffix ? ` ${labelSuffix}` : ""
      }`}
      icon={<Icon as={isArchive ? MdArchive : MdRestore} />}
      color="gray.600"
      {...rest}
    />
  );
}
